
























































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
  BFormDatepicker,
  BTooltip,
  BFormFile
} from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { PrestationAdditionnelle, UpdatePrestationAdditionnelleModel } from "@/api/models/prestationsAdditionnelles/prestationAdditionnelle";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { integer } from "vee-validate/dist/rules";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    BFormDatepicker,
    BTooltip,
    BFormFile
  },
  name: "update-prestation-additionnelle",
})
export default class UpdatePrestationAdditionnelle extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdatePrestationAdditionnelleSidebarActive!: boolean;
  @Prop({ required: true }) prestationAdditionnelleId!: string;

  loading = false;
  required = required;
  loadingContact = false;

  listTypePrestationAdditionnelle = []
  totalCountTypePrestationAdditionnelle = 0

  prestationAdditionnelle: UpdatePrestationAdditionnelleModel = {};

  async created() {
    await this.$http.myressif.entreprises
      .getPrestationAdditionnelleById(this.$route.params.id, this.prestationAdditionnelleId)
      .then((res: PrestationAdditionnelle) => {
        this.prestationAdditionnelle = res;
        this.loadingContact = true;
      });
    await this.getTypePrestationAdditionnelle();
  }

  resetForm() {
    this.prestationAdditionnelle = {};
  }

  async getTypePrestationAdditionnelle() {
    await this.$http.myressif.parametres
      .getByNom("type_prestationAdditionnelle_adherent")
      .then((res: any) => {
        this.listTypePrestationAdditionnelle = res ? JSON.parse(res.valeur) : []
      }
      ),
      (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.entreprises
      .updatePrestationAdditionnelleEntreprise(
        this.$route.params.id,
        this.prestationAdditionnelle.id,
        this.prestationAdditionnelle
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification de la prestation additionnelle",
            text: "Prestation additionnelle modifiée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-prestation-additionnelle");
        this.$emit("update:is-update-prestation-additionnelle-sidebar-active", false);
        this.loading = false;
      });
  }
}
